import { Component } from '@angular/core';

@Component({
  templateUrl: './cciq.component.html',
})
export class CCIQComponent {

}



// WEBPACK FOOTER //
// ./src/app/marketing/cciq.component.ts